/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import AppDispatcher from '../core/AppDispatcher'
import history from '../util/history'

const MenuActionTypes = {
  open: 'menu/open',
  close: 'menu/close',
  openSettingMenu: 'menu/open-setting-menu',
  closeSettingMenu: 'menu/close-setting-menu'
}

const MenuActions = {
  open: () => {
    AppDispatcher.dispatchWithType(MenuActionTypes.open)
  },

  close: () => {
    AppDispatcher.dispatchWithType(MenuActionTypes.close)
  },

  onToggleSettingMenu: open => {
    if (open) {
      AppDispatcher.dispatchWithType(MenuActionTypes.closeSettingMenu)
    } else {
      AppDispatcher.dispatchWithType(MenuActionTypes.openSettingMenu)
    }
  },
  onSelectSettingMenu: link => {
    AppDispatcher.dispatchWithType(MenuActionTypes.closeSettingMenu)
    history.push(link)
  }
}

export { MenuActions, MenuActionTypes }
